import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import salonService from "../../services/SalonService";
import SalonNotFound from "../salon/SalonNotFound";
import AppointmentBooking from "../appointmentBooking/AppointmentBooking";
import { useSalon } from "../../context/SalonContext";
import GlobalLoader from "../loadingIndicator/GlobalLoader";

export default function BookingWrapper() {
    const { token } = useParams();   // salonUuid from URL
    const { setSalonDetails, salonUuid, accessToken } = useSalon();
    const [loading, setLoading] = useState(true);
    const [validSalon, setValidSalon] = useState(false);

    useEffect(() => {
        const validateSalon = async () => {
            try {
                const uuid = token || salonUuid || localStorage.getItem("SALON_UUID");
                if (!uuid) {
                    setValidSalon(false);
                    return;
                }

                // ✅ validate from backend
                const response = await salonService.getSalonDetails(uuid);
                if (response?.data) {
                    setSalonDetails({
                        salonUuid: response.data.salonUuid,
                        salonName: response.data.salonName,
                    });
                    setValidSalon(true);
                } else {
                    setValidSalon(false);
                }
            } catch (err) {
                console.error("Salon validation failed:", err);
                setValidSalon(false);
            } finally {
                setLoading(false);
            }
        };

        validateSalon();
    }, [token]);

    if (loading) return <GlobalLoader />;
    if (!validSalon) return <SalonNotFound />;

    // 🔑 If not logged in → redirect to login (but salonUuid already stored)
    if (!accessToken) {
        return <Navigate to="/login?redirect=/booking" replace />;
    }

    // Logged in + valid salon → show booking page
    return <AppointmentBooking />;
}
